(function (angular) {
    'use strict';

    angular.module('profiles')

        /**
         *
         */
        .directive('profileSearchCriteria', ["profileHelper",
            function (profileHelper) {

                var controllerFn = ['$scope',
                    function ($scope) {

                        $scope.allowOtherProperties = profileHelper.allowOtherProperties();

                        $scope.isOpen = [];

                        $scope.validateLine = function ($index) {
                            $scope.checkSelector($index);
                            $scope.remValue($scope.properties[$index]);
                        };

                        $scope.remValue = function (criteria) {
                            if (criteria.logic == "==" || criteria.logic == "==!") {
                                criteria.value = "";
                            }
                            return true;
                        };

                        $scope.addValue = function (index) {
                            $scope.checkSelector(index);
                            $scope.remValue($scope.properties[index]);
                        };

                        $scope.addQuery = function () {
                            $scope.properties.push({
                                selector: "",
                                logic: "=~^",
                                value: ""
                            });
                        };

                        $scope.deleteQuery = function (query) {
                            var index = $scope.properties.indexOf(query);
                            $scope.properties.splice(index, 1);
                        };

                        $scope.open = function ($event, $index) {
                            $event.preventDefault();
                            $event.stopPropagation();     
                            for( var key in $scope.isOpen){
                                $scope.isOpen[key] = false;
                            }
                            $scope.isOpen[$index] = true;
                        };

                        $scope.checkSelector = function (index) {
                            return profileHelper.checkSelector($scope.properties[index]);
                        };


                    }
                ];

                return {
                    restrict: 'EA', 
                    scope: {
                        properties: "=",
                        profileSchema: "=",
                        // only using this as an out parameter!!!
                        form: "="
                    },
                    templateUrl: 'components/toolkit/profiles/templates/directive.profileSearchCriteria.html',
                    controller: controllerFn
                };

            }]);

})(window.angular);
